// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3HpcP","inputDescription":"styles_inputDescription__3UNA7"};